<template>
  <div>
    <section>
      <v-card class="transparent elevation-0">
        <v-container container--fluid grid-list-xl>
          <ZonesHeader
            id="header"
            v-if="propsHeader"
            v-on:switch-change="keyZoneTable++; keyClientTable++"
            v-on:export-btn-click="exportDialog = true"
            v-on:alert="displayErrorDialog"
            :props-header="propsHeader"

            @input="searchSuburb"
          ></ZonesHeader>
        </v-container>
        <v-divider color="#42a5f5"></v-divider>

        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="blue"
          grow
          slider-color="cyan accent-4"
        >
        <v-tab key="0">
          <v-icon class="mr-4">map</v-icon>
          Zones
        </v-tab>
        <v-tab key="1">
          <v-icon class="mr-4">fas fa-map-marker-alt</v-icon>
          Locations
        </v-tab>
        <v-tab key="2" v-if="propsHeader.isInternalUser">
          <v-icon class="mr-4">fas fa-user</v-icon>
          Clients
        </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            :key="0"
          >
            <v-card flat>
              <v-card-text class="pa-0">
                <ZonesDataTable
                  v-on:save-change="keyZoneTable++"
                  v-on:error="displayErrorDialog"
                  :key="keyZoneTable"
                  :props-header="propsHeader"
                  :zones-rendered="zonesRendered"
                  :searching="searching"
                  :select-zone="selectRow"
                  height="600px"
                  fixed-header
                ></ZonesDataTable>
              </v-card-text>
            </v-card>

          </v-tab-item>

          <v-tab-item
          :key="1"
        >
          <v-card flat>
            <v-card-text class="pa-0">
              <ZoneLocation :key="keyLocations" :item="zoneClicked">
              </ZoneLocation>
            </v-card-text>
          </v-card>
        </v-tab-item>

          <v-tab-item
            :key="2" v-if="propsHeader.isInternalUser"
          >
            <v-card flat>
              <v-card-text class="pa-0">
                <ClientsDataTable
                  :key="keyClientTable"
                  :restricted="propsHeader.showRestricted"
                  :clients-clicked="clientsClicked"
                  v-if="clientsClicked">
                </ClientsDataTable>
              </v-card-text>
            </v-card>
          </v-tab-item>

        </v-tabs-items>
      </v-card>
    </section>

    <v-dialog
      persistent
      v-model="exportDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <h3>Select the zones to export</h3>
        </v-card-title>
        <v-card-actions>
            <template>
                <v-autocomplete
                  v-model="selectedZones"
                  :items="zones"
                  item-value="id"
                  item-text="name"
                  label="Choose zones to export..."
                  dense
                  chips
                  small-chips
                  multiple
                  solo
                  deletable-chips
                >
                </v-autocomplete>
            </template>
        </v-card-actions>
        <v-card-actions class="justify-end">
            <v-btn text @click="exportDialog = false" color="blue-grey lighten-2">Cancel</v-btn>
            <v-btn text @click="csvExportAll()" color="indigo">All</v-btn>
            <v-btn text @click="csvExport()" color="blue darken-1">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="errorDialog" width="350px">
      <v-card>
        <v-card-title>
         <h3>ALERT</h3>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="12" class="text-center">{{errorMessage}}</v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
    import axios from 'axios'
    import ZonesHeader from "./Zones/ZonesHeader";
    import ZonesDataTable from "./Zones/ZonesDataTable";
    import ZoneLocation from "./Zones/ZoneLocation";
    import ClientsDataTable from "./Zones/ClientsDataTable";

    export default {
        name: "Zones",
        components: {
            ClientsDataTable,
            ZoneLocation,
            ZonesDataTable,
            ZonesHeader
        },
        data() {
            return {
                tab: 0,
                propsHeader: {
                    'search': null,
                    'isInternalUser': null,
                    'clients': null,
                    'client': null,
                    'suburbs': null,
                    'suburb': null,
                    'postcode': null,
                    'showRestricted': true,
                    'showNonUsed': false,
                },
                keyZoneTable: 0,
                keyClientTable: 0,
                keyLocations: 0,
                client: null,
                exportDialog: false,
                searching: false,
                search: '',
                showRestricted: true,
                errorDialog: false,
                errorMessage: null,
                postcode: null,
                zoneClicked: {location: null},
                clientsClicked: null,
                selectedZones: [],
            }
        },
        methods: {
            csvExport() {
                window.open(process.env.API_URL + '/zones/csv?key=' + encodeURI(this.$store.state.auth.key) + '&zones=' + this.selectedZones.join(), '_blank')
            },
            csvExportAll() {
                window.open(process.env.API_URL + '/zones/csv?key=' + encodeURI(this.$store.state.auth.key) + '&all=true', '_blank')
            },
            selectRow(item) {
                if (this.propsHeader.isInternalUser) {
                    axios.get(process.env.API_URL + '/zones/' + item.id + '/clientwindows')
                        .then((response) => {
                            this.zoneClicked = item;
                            this.tab = 1;
                            this.keyZoneTable++;

                            this.clientsClicked = response.data;
                        })
                        .catch((response) => {
                            this.displayErrorDialog('ERROR ' + response.response.data.error);
                        })
                } else {
                    this.zoneClicked = item;
                    this.keyLocations++;
                    this.tab = 1;
                }
            },
            displayErrorDialog(message) {
                this.errorMessage = message;
                this.errorDialog = true;
            },
            filterSuburbs(suburbs) {
                if (this.isInternalUser && !this.propsHeader.client) return suburbs;
                if (!this.clientZoneIds.length) return suburbs;
                return suburbs.filter(s => this.clientZoneIds.includes(s.zone));
            },
            searchSuburb(val) {
                if( val !== '' || val !== null ) {
                    axios.get(process.env.API_URL + '/zones/autocomplete?s=' + val)
                        .then((response) => {
                            return this.propsHeader.suburbs = this.filterSuburbs(response.data);
                        })
                        .catch((error) => {
                            alert("An unknown error has occurred (Couldn't get suburb...)");
                            return [];
                        })
                } else {
                    axios.get(process.env.API_URL + '/zones/autocomplete')
                        .then((response) => {
                            return this.propsHeader.suburbs = this.filterSuburbs(response.data);
                        })
                        .catch((error) => {
                            alert("An unknown error has occurred (Couldn't get suburb...)");
                            return [];
                        })
                }
            }
        },
        mounted() {
            let today = new Date();
            console.log('UTC Offset ' + today.toString().split(' ')[5].split('+')[1]);
            console.log('UTC ' + today.getUTCHours() + ':' + today.getUTCMinutes() + ':' + today.getUTCSeconds());
            this.propsHeader.isInternalUser = this.isInternalUser;
        },
        computed: {
            isInternalUser() {
                return this.$store.getters['auth/isInternalUser'];
            },
            zoneViewAllPermission() {
                return this.isInternalUser || this.$store.getters['auth/hasPermission']('zone_view_all');
            },
            clientRegionIds() {
                const allRegions = this.$store.state.auth.regions;
                const selectedClient = this.propsHeader.client;
                if (selectedClient && selectedClient.default_country) {
                    return allRegions.filter(r => r.country === selectedClient.default_country).map(r => r.id);
                }
                const regions = this.$store.getters['auth/regions'];
                return regions.map(r => r.id);
            },
            clientZoneIds() {
                if (this.zones === null) return [];
                return this.zones
                    .filter((zone) => this.clientRegionIds.includes(zone.region_id))
                    .map(zone => zone.id);
            },
            zonesRendered() {
                if (this.zones === null) return [];
                let zones = this.zones.filter((zone) => this.clientRegionIds.includes(zone.region_id));
                zones.map((zone) => {
                        let tw_rendered = {
                            Monday: [],
                            Tuesday: [],
                            Wednesday: [],
                            Thursday: [],
                            Friday: [],
                            Saturday: [],
                            Sunday: []
                        };
                        let filtered_tw = null;
                        if (this.propsHeader.isInternalUser) {
                            // Restricted Switch
                            // TW Filtered by restricted or not

                            filtered_tw = zone.time_windows.filter((tw) => {
                                return ((tw.restricted === this.propsHeader.showRestricted) || (tw.restricted === false))
                            });
                        } else {
                            // For clients they can choose between used/not used tw

                            filtered_tw = zone.time_windows;
                        }
                        if (this.zoneViewAllPermission) {
                            filtered_tw = filtered_tw.filter((tw) => {
                                return ((tw.in_use === true) || (this.propsHeader.showNonUsed === true))
                            })
                        }

                        for (var i = 0; i < filtered_tw.length; i++) {
                            tw_rendered[filtered_tw[i].day].push(filtered_tw[i]);
                        }
                        zone['tw_rendered'] = tw_rendered;
                        return zone
                    }
                );

                if (this.propsHeader.suburb) {
                    let zonesFilteredSuburb = zones.filter((zone) => {
                        return zone.id === this.propsHeader.suburb.zone;
                    });
                    return zonesFilteredSuburb;
                } else {
                    return zones
                }
            },

        },
        asyncComputed: {
            async zones() {
                this.searching = true;
                let suffix = '';

                if (this.propsHeader.client === null || this.propsHeader.client === undefined || this.propsHeader.client === '') {
                    suffix = '/zones?timewindow=true&locations=true';
                } else if (this.propsHeader.client !== null) {
                    suffix = '/zones?timewindow=true&locations=true&client=' + this.propsHeader.client.id;
                }

                if (this.propsHeader.postcode !== null && this.propsHeader.postcode.length === 4) {
                    suffix = suffix + '&postcode=' + this.propsHeader.postcode;
                }
                if (this.zoneViewAllPermission && this.propsHeader.showNonUsed) {
                    suffix = suffix + '&show_all=true'
                }

                console.log(suffix);

                let zones = await axios.get(process.env.API_URL + suffix)
                    .then((response) => {
                        if (!Array.isArray(response.data)) {
                            // Only one element in array
                            return [response.data];
                        } else {
                            return response.data;
                        }
                    })
                    .catch((response) => {
                            return [];
                        }
                    );
                zones.map((zone) => {
                    return zone.selected = false
                });
                this.searching = false;
                this.keyZoneTable++;
                return zones;
            },
            async clients() {
                if (!this.isInternalUser) return [];
                return await axios.get(process.env.API_URL + '/clients')
                    .then((response) => {
                        return Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                    })
                    .catch((error) => {
                        alert("An unknown error has occurred (Couldn't get clients...)");
                        return [];
                    })
            },
            async suburbs() {
                    if (this.propsHeader.suburb === null) {
                        return await axios.get(process.env.API_URL + '/zones/autocomplete')
                            .then((response) => {
                                return this.filterSuburbs(response.data);
                            })
                            .catch((error) => {
                                alert("An unknown error has occurred (Couldn't get suburb...)");
                                return [];
                            })
                    }

            },
        },
        watch: {
            clients: function () {
                this.propsHeader.clients = this.clients;
            },
            suburbs: function () {
                this.propsHeader.suburbs = this.suburbs;
            },
            isInternalUser: function () {
                this.propsHeader.isInternalUser = this.isInternalUser;
            }
        }
    }
</script>

<style scoped>

  .v-card__actions .v-input--selection-controls {
    margin: 0;
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Zones.vue